import Offcanvas from 'react-bootstrap/Offcanvas';
import { Link } from 'react-router-dom';

const OffcanvasComponent = (props) => {
  return (
    <>
      <Offcanvas show={props?.show} onHide={props?.toggleCanvas} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Account Settings</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="settings-menu">
            
            {/* Profile Settings */}
            <div className="setting-section mb-4">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-person-circle me-2"></i>Profile Settings
              </h6>
              <div className="list-group list-group-flush">
                <Link to="/profile" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-person me-3"></i>Edit Profile
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-key me-3"></i>Change Password
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-shield-check me-3"></i>Security Settings
                </Link>
              </div>
            </div>

            {/* Business Settings */}
            <div className="setting-section mb-4">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-building me-2"></i>Business Settings
              </h6>
              <div className="list-group list-group-flush">
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-gear me-3"></i>Company Details
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-credit-card me-3"></i>Payment Methods
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-file-text me-3"></i>Tax Information
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-bank me-3"></i>Banking Details
                </Link>
              </div>
            </div>

            {/* Notification Settings */}
            <div className="setting-section mb-4">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-bell me-2"></i>Notifications
              </h6>
              <div className="list-group list-group-flush">
                <div className="list-group-item border-0 py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <span><i className="bi bi-envelope me-3"></i>Email Notifications</span>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" defaultChecked />
                    </div>
                  </div>
                </div>
                <div className="list-group-item border-0 py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <span><i className="bi bi-phone-vibrate me-3"></i>SMS Alerts</span>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" defaultChecked />
                    </div>
                  </div>
                </div>
                <div className="list-group-item border-0 py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <span><i className="bi bi-calendar-event me-3"></i>Booking Updates</span>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" defaultChecked />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* System Preferences */}
            <div className="setting-section mb-4">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-sliders me-2"></i>Preferences
              </h6>
              <div className="list-group list-group-flush">
                <div className="list-group-item border-0 py-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <span><i className="bi bi-moon me-3"></i>Dark Mode</span>
                    <div className="form-check form-switch">
                      <input className="form-check-input" type="checkbox" />
                    </div>
                  </div>
                </div>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-globe me-3"></i>Language & Region
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-currency-exchange me-3"></i>Currency Settings
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-clock me-3"></i>Timezone
                </Link>
              </div>
            </div>

            {/* Support & Help */}
            <div className="setting-section mb-4">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-question-circle me-2"></i>Support & Help
              </h6>
              <div className="list-group list-group-flush">
                <Link to="/faq" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-book me-3"></i>Help Center
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-chat-dots me-3"></i>Contact Support
                </Link>
                <Link to="#" className="list-group-item list-group-item-action border-0 py-2">
                  <i className="bi bi-file-earmark-text me-3"></i>Terms & Privacy
                </Link>
              </div>
            </div>

            {/* Quick Actions */}
            <div className="setting-section">
              <h6 className="fw-bold text-primary mb-3">
                <i className="bi bi-lightning me-2"></i>Quick Actions
              </h6>
              <div className="d-grid gap-2">
                <button className="btn btn-outline-primary btn-sm">
                  <i className="bi bi-download me-2"></i>Export Data
                </button>
                <button className="btn btn-outline-secondary btn-sm">
                  <i className="bi bi-arrow-clockwise me-2"></i>Clear Cache
                </button>
              </div>
            </div>

          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default OffcanvasComponent;